/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import Dialog from '../components/dialog';
import Stack from '../components/stack';
import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import { categories } from './categories';

interface CategoryDialogProps {
  onClick?: () => void;
}

const ButtonKanji = css`
width: 100%;
height: auto;
flex-direction: row;
justify-content: center;
font-size: 30px;
color: light-dark(var(--green-700), var(--green-500));
font-family: "M PLUS Rounded 1c", sans-serif;
font-weight: 500; 
font-style: normal;
@media (min-width: 640px) {
  font-size: 48px;
}
`;

const ButtonIcon = css`
width: 100%;
height: auto;
flex-direction: row;
justify-content: center;
font-size: 36px;
color: light-dark(var(--green-700), var(--green-500));
font-family: "M PLUS Rounded 1c", sans-serif;
font-weight: 500; 
font-style: normal;
@media (min-width: 640px) {
  font-size: 48px;
}
`;

const ButtonText = css`
padding: 16px 0;
color: light-dark(var(--green-1000), var(--green-050));
font-size: 18px;
@media (min-width: 640px) {
  font-size: 24px;
}
`;

const CategoryLink = styled(Link)`
text-decoration: none;
padding: 16px 24px;
text-align: center;
font-family: "Aleo", serif;
font-weight: 700;
font-optical-sizing: auto;
font-style: normal;
border-radius: 8px;
&:hover {
  background: light-dark(var(--action-tertiary-hover-light), var(--action-tertiary-hover-dark));
}

`;

const GridStyles = css`
grid-template-columns:  1fr;
column-gap: 24px;
row-gap: 36px;
@media (min-width: 360px) {
  grid-template-columns:  1fr 1fr;
  column-gap: 24px;
  row-gap: 36px;
}
@media (min-width: 430px) {
  grid-template-columns:  1fr 1fr;
  gap: 36px;
}
@media (min-width: 900px) {
  grid-template-columns:  1fr 1fr 1fr;
}
@media (min-width: 1280px) {
  grid-template-columns:  1fr 1fr 1fr 1fr;
}
`;

const CategoryDialog: React.FC<CategoryDialogProps> = ({ onClick }) => {
  return (
    <Dialog title="Select a category" onClick={onClick} presentation="dialog">
      <Stack variant='grid' css={GridStyles}>
        {categories.map((category) => (
          <CategoryLink key={category.to} to={category.to}>
            <Stack>
              <Stack css={ButtonKanji}>{category.kanji}</Stack>
              <Stack css={ButtonText}>{category.label}</Stack>
              <Stack css={ButtonIcon}>{category.icon}</Stack>
            </Stack>
          </CategoryLink>
        ))}
      </Stack>
    </Dialog>
  );
};

export default CategoryDialog;
